// DEV-ONLY · PREIS-/ABSCHLUSSBÜHNE (Preview).
// Rendert die freigegebene, geteilte Live-Komponente AboPreisAbschlussStage 1:1
// (identisch zu /abo) — nur mit Dev-Rahmen/Label. Single Source of Truth = die Komponente.
import { useAboSeite } from "@/pages/abo/useAboSeite";
import AboPreisAbschlussStage from "@/components/abo/AboPreisAbschlussStage";

export default function AboPreisAbschlussDevPreview() {
  const {
    priceState,
    currencySymbol,
    employeeCount,
    setEmployeeCount,
    totalText,
    startTrial,
    trialLoading,
    trialError,
  } = useAboSeite();
  const setEmp = (n) => setEmployeeCount(Math.max(1, Math.min(250, n)));

  return (
    <div style={{ minHeight: "100vh", background: "#e9eef4" }} data-testid="abo-preis-dev">
      <div
        style={{
          maxWidth: 1024,
          margin: "0 auto",
          padding: "18px 20px 0",
          font: '600 .72rem/1.4 "Outfit",system-ui,sans-serif',
          letterSpacing: ".14em",
          textTransform: "uppercase",
          color: "#94a3b8",
        }}
      >
        Preis-/Abschlussbühne · Preview · Master-Bild 1:1 + unsichtbare Technik · Live /abo unberührt
      </div>
      <AboPreisAbschlussStage
        priceState={priceState}
        currencySymbol={currencySymbol}
        employeeCount={employeeCount}
        setEmp={setEmp}
        totalText={totalText}
        startTrial={startTrial}
        trialLoading={trialLoading}
        trialError={trialError}
      />
    </div>
  );
}
